// extracted by mini-css-extract-plugin
module.exports = {"UlTag":"TermsOfUse_UlTag__27pbc","h5Tag":"TermsOfUse_h5Tag__3VbHA"};